export default "__VITE_ASSET__2f3ec3f4__"